export enum XpassTripTypeLabels {
  ARRIVAL = 'Arrival',
  DEPARTURE = 'Departure',
  ROUND_TRIP = 'Round Trip',
  NONE = 'None',
}
